import MaterialTable from "material-table";
import { Paper } from "@material-ui/core";
import { ToastContainer } from "react-toastify";
import _ from "lodash";

import { getTrans as t } from "../../Localization/translations";
import authHeader from "../../services/auth-header";
import { API } from "../../backend";

function LeagalEntities() {
  return (
    <div className="container-fluid py-4 pt-2">
      <div className="row py-2 mt-2">
        <ToastContainer />
        <div className="col-md-12">
          <div className=" mb-0">
            <div className="header pb-0">
              <div className="d-lg-flex">
                <div>
                  <h5 className="mb-0 tc">{t("Legal Entities")}</h5>
                </div>
              </div>
            </div>
            <div className="body">
              <div className="p-0">
                <MaterialTable
                  style={{
                    padding: "0.5rem 0.5rem",
                    backgroundColor: "var(--bs-table-bg)",
                    borderBottomWidth: "1px",
                    boxShadow: "inset 0 0 0 9999px var(--bs-table-accent-bg)",
                  }}
                  columns={[
                    {
                      title: `${t("Name")}`,
                      field: "name",
                      render: (rowData) => (
                        <>
                          <div className="d-xl-none tc d-md-none d-lg-none">{t("Name")}</div>
                          <div>{rowData.name}</div>
                        </>
                      ),
                      headerStyle: {
                        verticalAlign: "inherit",
                        fontWeight: "bold",
                        textAlign: "left",
                      },
                      cellStyle: {
                        textAlign: "left",
                        fontSize: 12,
                      },
                    },
                    {
                      title: `${t("Address")}`,
                      field: "address",
                      render: (rowData) => (
                        <>
                          <div className="d-xl-none tc d-md-none d-lg-none">{t("Address")}</div>
                          <div>{rowData.address}</div>
                        </>
                      ),
                      headerStyle: {
                        verticalAlign: "inherit",
                        fontWeight: "bold",
                        textAlign: "left",
                      },
                      cellStyle: {
                        textAlign: "left",
                        fontSize: 12,
                      },
                    },
                  ]}
                  data={(query) =>
                    new Promise((resolve, reject) => {
                      let url = API + "accounting/leaglentities/?";
                      url += "per_page=" + query.pageSize;
                      url += "&page=" + (query.page + 1);
                      fetch(url, { headers: authHeader() })
                        .then((response) => response.json())
                        .then((result) => {
                          resolve({
                            data:
                              query.orderBy && query.orderDirection
                                ? _.orderBy(
                                    result.data,
                                    [query.orderBy.field],
                                    [query.orderDirection]
                                  )
                                : result.data,
                            page: result.page - 1,
                            totalCount: result.total,
                          });
                        });
                    })
                  }
                  components={{
                    Container: (props) => (
                      <div id="Payment">
                        <Paper {...props} />
                      </div>
                    ),
                  }}
                  options={{
                    headerStyle: {
                      backgroundColor: "white",
									color: "#245C7F",
                      fontSize: 12,
                    },
                    rowStyle: (rowData, index) => {
                      if (index % 2) {
                        return { backgroundColor: "#fff" };
                      }
                    },
                    sorting: true,
                    search: false,
                    toolbar: false,
                    paging: true,
                    pageSize: 10,
                    emptyRowsWhenPaging: false,
                    pageSizeOptions: [10, 15, 20, 50],
                    paginationType: "stepped",
                    showFirstLastPageButtons: false,
                    actionsColumnIndex: -1,
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default LeagalEntities;
